module.exports = __webpack_public_path__ + "img/global-not_homework.png?71473457";